<template>
<v-container>
<div class="page-header">
    <v-row>
      <v-col >
        <ul>
          <li
            v-for="(breadcrumb, idx) in breadcrumbList"
            :key="idx"
            @click="routeTo(idx)"
            :class="{ linked: !!breadcrumb.link }"
          >
            {{ $t(breadcrumb.name, { value: "default" }) }}
            
          </li>
        </ul>
      </v-col>
    </v-row>
  </div>
</v-container>
  
</template>

<script>
export default {
  components: {
  },
  filters: {
    internalization: function() {
      return this.$t("message.pageKm.loco", { value: "default" });
    }
  },
  methods: {
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    },
    routeTo(proute) {
      if (this.breadcrumbList[proute].link) {
        this.$router.push(this.breadcrumbList[proute].link);
      }
    },
  },
  mounted() {
    this.updateList();
  },
  name: "PortalBreadcumb",
  data: () => ({
    breadcrumbList: [],
  }),
  watch: {
    $route() {
      this.updateList;
    },
  },
};
</script>

<style scoped>
.page-header {
  width: 100%;
  padding-right: 70px;
  padding-top: 15px;
  padding-bottom: 15px;
  display: block;
  color: #00475a;
  position: fixed;
  z-index: 5;
  top: 113px;
  right: 0px;
  margin-left:100px;
  padding-left: 309px;
  background-color: #fff;
}

ul {
  display: flex;
  list-style-type: none;
  margin: 0px;
  padding: 0px;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  font-weight: bold;
  font-size: 0.8em;
  align-items: center;
}

ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 0.8em;
  margin: 0 0.5em;
  
}

ul > li:last-child{
  color:#7FC7B2;
}
.linked {
  cursor: pointer;
}
</style>
